export const ConditionalWrapper = ({ condition, wrapper, children }: { condition: any; wrapper: any; children: any }) => (condition ? wrapper(children) : children)
